import Route from '@ember/routing/route';

export default class ConnectAnalyticsIndexRoute extends Route {
  title = 'Connect · Analytics · Envoy';
}
